import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import Grid from "@material-ui/core/Grid";
import {HowToVoteOutlined, CalendarTodayOutlined, DeviceHubOutlined, PinDropOutlined, VerifiedUser, PhoneOutlined, ImageAspectRatioOutlined, HdrWeakOutlined, HdrStrongOutlined,
	AlternateEmailOutlined,
	ArrowBack,
	GrainOutlined,
	PhoneIphoneOutlined,
	StreetviewOutlined,
	TurnedInNotOutlined
} from "@material-ui/icons"
import Divider from "@material-ui/core/Divider";
import DraggableModal from "../../../Include/DraggableModal/DraggableModal";
import {EnteroSolo, FieldsJs, showSpinner} from "../../../../settings/General/General";
import Slide from "@material-ui/core/Slide";
import {RutaService} from "../../../../services/_Sis/RutaService/RutaService";
import {BotonAccionAbrirModal, BotonAccionFooterModal, TituloHeaderModal} from "../../../Include/MiniComponents/GlobalComponent";
import {ReclamacionesService} from "../../../../services/_Sis/ReclamacionesService/ReclamacionesService";
import {KeyboardDatePicker} from '@material-ui/pickers';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Typography from "@material-ui/core/Typography";
import {CatService} from "../../../../services/_Cat/CatService/CatService";
import ArchivosExpedientes from "./ArchivosExpedientes";
import SeccionExpedientes from "./SeccionExpedientes";
import {CONFIG} from "../../../../settings/Config/Config";
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {DropboxApi} from "../../../../settings/Dropbox/DropboxApi";
import {Dropbox} from 'dropbox';
import Fab from "@material-ui/core/Fab";
import ModalValidacion from "./ModalValidacion";
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import moment from "moment";
import {FileBase64} from "../../../../settings/FileBase64/FileBase64";
import {ClienteService} from "../../../../services/_Sis/ClienteService/ClienteService";
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";


class ModalReclamaciones extends Component {
	
	state = {};
	Usr = {};
	
	constructor(props) {
		super(props);
		
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		
		this.state = {
			modal: {
				open: false
			},
			
			tipo: props.tipo,
			
			id_reclamacion: (props.item || {}).id_reclamacion,

			id_cat_estado_concluido_pendiente: '',
			id_cat_entidad_federativa: '',
			clave_municipio: '',
			clave_localidad: '',
			clave_colonia: '',
			id_cat_medio_recepcion_canal: '',
			id_cat_nivel_atencion: '',
			id_cat_robo_identidad: '',
			id_cat_sentido_resolucion: '',
			id_cat_tipo_persona: '',
			id_cat_sexo: '',
			edad: '',
			id_cat_monetario: '',
			id_cat_operacion: '',
			id_cat_producto_servicio: '',
			id_cat_tipo_credito: '',
			id_cat_causa: '',
			operacion: '',
			producto: '',
			tipo_credito: '',
			causa: '',
			id_cat_anio: '',
			id_cat_trimestre: '',
			fecha_reclamacion: null,
			fecha_atencion: null,
			fecha_resolucion: null,
			fecha_notificacion: null,
			fecha_abono_importe: null,
			
			
			cat_estado_concluido_pendiente: [],
			cat_entidad_federativa: [],
			cat_entidades: [],
			cat_codigo_postal: [],
			cat_localidad: [],
			cat_colonia: [],
			cat_medio_recepcion_canal: [],
			cat_nivel_atencion: [],
			cat_robo_identidad: [],
			cat_sentido_resolucion: [],
			cat_tipo_persona: [],
			cat_sexo: [],
			cat_monetario: [],
			cat_operacion: [],
			cat_producto_servicio: [],
			cat_tipo_credito: [],
			cat_causa: [],
			cat_anio: [],
			cat_trimestre: [],
		
			
			activo: true,

		};
		
	}
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}, () => {
			//this.valorTotal();
		}));
		
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			}
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	openModal = () => {
		const props = this.props;
		this.setState({
			modal: {
				open: true
			}
		});
		console.log(this.state, props);
	};
	
	open = () => {
		this.init().then(r => {
			setTimeout(() => this.openModal());
		}).catch(e => {
			console.log(e);
		});
	};
	
	RefreshInit = () => {
		this.init();
	};
	
	init = () => {
		return new Promise((resolve) => {
			resolve(true);
		});
	};
	
	save = () => {
		try {
			/*if (!FieldsJs.Field(this.state.fecha_ingreso)) {
				throw Object({
					status: false,
					popup_alert: false,
					mensaje: "Campo fecha de ingreso es requerido.",
				});
			}*/
			if (this.state.id_reclamacion > 0) {
				ReclamacionesService.Modificar(this.state).then((response) => {
					this.close();
					this.props.RefreshList();
					this.props.showSnackBars('success', response.mensaje);
				}).catch((error) => {
					this.props.showSnackBars('error', error.mensaje);
				});
			} else {
				ReclamacionesService.Agregar(this.state).then((response) => {
					this.close();
					this.props.RefreshList(response.data);
					this.props.showSnackBars('success', response.mensaje);
				}).catch((error) => {
					this.props.showSnackBars('error', error.mensaje);
				});
			}
		} catch (e) {
			this.props.showSnackBars('error', e.mensaje);
		}
	};
	
	add = () => {
		const {item, catalogos} = this.props;
		console.log("PROPS >>>>>>>>> ", this.props);
		this.setState({
			listar_cat_monetario: [{id_cat_monetario: 1, monetario: 'SI'}, {id_cat_monetario: 2, monetario: 'NO'}],
			razon_social: 'Operadora Procea del Centro, S.A. de C.V., SOFOM, E.N.R.',
			sector: 'Sociedades Financieras de Objeto Múltiple E.N.R.',
			cat_estado_concluido_pendiente: catalogos.cat_estado_concluido_pendiente ?? [],
			cat_entidad_federativa: catalogos.cat_entidad_federativa ?? [],
			cat_medio_recepcion_canal: catalogos.cat_medio_recepcion_canal ?? [],
			cat_nivel_atencion: catalogos.cat_nivel_atencion ?? [],
			cat_robo_identidad: catalogos.cat_robo_identidad ?? [],
			cat_sentido_resolucion: catalogos.cat_sentido_resolucion ?? [],
			cat_tipo_persona: catalogos.cat_tipo_persona ?? [],
			cat_operacion: catalogos.cat_operacion ?? [],
			cat_sexo: catalogos.cat_sexo ?? [],
			cat_monetario: catalogos.cat_monetario ?? [],
			cat_anio: catalogos.cat_anio || [],
			cat_trimestre: catalogos.cat_trimestre || [],
			
			cat_entidades: [],
			cat_codigo_postal: [],
			cat_localidad: [],
			cat_colonia: [],
			cat_producto_servicio: [],
			cat_tipo_credito: [],
			cat_causa: [],
			
			
			id_cat_estado_concluido_pendiente: '',
			id_cat_entidad_federativa: '',
			clave_municipio: '',
			clave_localidad: '',
			clave_colonia: '',
			id_cat_medio_recepcion_canal: '',
			id_cat_nivel_atencion: '',
			id_cat_robo_identidad: '',
			id_cat_sentido_resolucion: '',
			id_cat_tipo_persona: '',
			id_cat_sexo: '',
			id_cat_anio: '',
			id_cat_trimestre: '',
			
			edad: '',
			id_cat_monetario: '',
			operacion: '',
			producto: '',
			tipo_credito: '',
			causa: '',
			
			id_cat_nacionalidad: '',
			id_cat_estado_republica: '',
			id_cat_tipo_cliente: '',
			id_cat_peps: '',
			id_cat_edad_cliente: '',
			id_cat_antiguedad_empresa: '',
			id_cat_persona_bloqueada: '',
			id_cat_actividad_economica: '',
			id_cat_actua_cuenta_propia: '',
			id_cat_numero_transacciones: '',
			id_cat_monto_transacciones: '',
			id_cat_monto_ingreso: '',
			id_cat_cambio_perfil_transaccional: '',
			id_cat_tipo_moneda: '',
			id_cat_forma_pago: '',
			id_cat_domicilio: '',
			id_cat_visita_ocular: '',
			id_cat_otro_riesgo: '',
			id_cat_alerta_emitida: '',
			id_cat_mitigante: '',
			id_cat_autorizacion: '',
			id_cat_cumplimiento: '',
			ponderacion: '',
			observaciones: '',
			valor_total: 0,
			activo: true,
			
		});
		this.open();
	};
	
	edit = () => {
		const {item} = this.props;
		console.log(this.props);
		
		this.ListarReclamaciones().then((response) => {
			this.setState({
				id_cat_nacionalidad: item.id_cat_nacionalidad.toString() || '',
				
			});
		});
		
		this.setState({
			id_reclamacion: item.id_reclamacion || '',
			activo: (item.activo === 1),
		});
		
		this.open();
	};
	
	view = () => {
		const {item} = this.props;
		console.log(this.props);
		
		this.ListarReclamaciones().then((response) => {
			this.setState({
				id_cat_nacionalidad: item.id_cat_nacionalidad.toString() || '',
			});
		})
		
		this.setState({
			id_reclamacion: item.id_reclamacion || '',
			activo: (item.activo === 1),
		});
		
		this.open();
	};
	
	ListMunicipio = (id_cat_entidad_federativa) => {
		this.setState({
			cat_entidades: [],
		});
		this.props.catalogosEntidad(id_cat_entidad_federativa).then((response) => {
			this.setState({
				cat_entidades: response.data || [],
			});
		})
	}
	
	ListCodigoPostal = (clave_municipio) => {
		this.setState({
			cat_codigo_postal: [],
		});
		this.props.catalogosEntidadCodigoPostal(this.state.id_cat_entidad_federativa, clave_municipio).then((response) => {
			this.setState({
				cat_codigo_postal: response.data || [],
			});
		})
	}
	
	ListLocalidad = (codigo_postal) => {
		this.setState({
			cat_localidad: [],
		});
		this.props.catalogosEntidadLocalidad(this.state.id_cat_entidad_federativa, this.state.clave_municipio, codigo_postal).then((response) => {
			this.setState({
				cat_localidad: response.data || [],
			});
		})
	}

	ListColonia = (clave_localidad) => {
		this.setState({
			cat_colonia: [],
		});
		this.props.catalogosEntidadColonia(this.state.id_cat_entidad_federativa, this.state.clave_municipio, this.state.codigo_postal, clave_localidad).then((response) => {
			this.setState({
				cat_colonia: response.data || [],
			});
		})
	}
	
	ListProductoServicio = (operacion, producto, tipo_credito) => {
		if (FieldsJs.Field(operacion) && FieldsJs.Field(producto) && FieldsJs.Field(tipo_credito)) {
			this.setState({
				cat_causa: [],
			});
		} else if (FieldsJs.Field(operacion) && FieldsJs.Field(producto)) {
			this.setState({
				cat_tipo_credito: [],
				cat_causa: [],
			});
		} else {
			this.setState({
				cat_producto_servicio: [],
				cat_tipo_credito: [],
				cat_causa: [],
			});
		}
		
		this.props.catalogosProductoServicio(operacion ?? null, producto ?? null, tipo_credito ?? null).then((response) => {
			if (FieldsJs.Field(operacion) && FieldsJs.Field(producto) && FieldsJs.Field(tipo_credito)) {
				this.setState({
					cat_causa: response.data,
				});
			} else if (FieldsJs.Field(operacion) && FieldsJs.Field(producto)) {
				this.setState({
					cat_tipo_credito: response.data,
					cat_causa: [],
				});
			} else {
				this.setState({
					cat_producto_servicio: response.data,
					cat_tipo_credito: [],
					cat_causa: [],
				});
			}
		})
	}

	trimestre = () => {
		let tr = FieldsJs.Copy(this.state.cat_trimestre);
		let trimestre = "Trimestre 1 (Enero-Marzo)";
		for (let i = 0; i < tr.length; i++) {
			if (Number(this.state.id_cat_trimestre) === Number(tr[i].id_cat_trimestre)) {
				trimestre = tr[i].trimestre;
			}
		}
		return trimestre;
	}
	
	render() {
		
		let funcion;
		
		switch (this.state.tipo) {
			case 'edit':
				funcion = this.edit;
				break;
			case 'add':
				funcion = this.add;
				break;
			case 'view':
				funcion = this.view;
				break;
			default:
				funcion = () => {
				};
		}
		
		return (
			<div>
				
				{this.props.componente ? (
					<Fragment>
						<span
							style={{cursor: 'pointer'}}
							children={this.props.componente}
							onClick={() => funcion()}
						/>
					</Fragment>
				) : (
					<BotonAccionAbrirModal
						id={this.state.id_reclamacion}
						tipo={this.state.tipo}
						onClick={() => funcion()}
					/>
				)}
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'md'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				>
					
					<DialogTitle>
						<TituloHeaderModal
							tipo={this.state.tipo}
							titulo={'Reclamación'}
						/>
					</DialogTitle>
					
					<DialogContent>
						
						<Grid container spacing={2}>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{fontWeight: 500, textAlign: 'center', color: '#3f51b5'}}>
								TRIMESTRE A INFORMAR: {this.trimestre()} - DICIEMBRE del año {this.state.anio ? this.state.anio: new Date().getFullYear()}.
							</Grid>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<div style={{height: '96%', background: '#EFF0F4', borderRadius: 6, padding: '15px'}}>
									<Grid container spacing={2}>
										
										<Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
											
											<TextField
												margin="none"
												name="razon_social"
												label="Denominación o Razón Social"
												type="text"
												fullWidth
												value={this.state.razon_social}
												InputLabelProps={{shrink: true}}
												onChange={(e) => {
													this.handleChange(e);
												}}
											/>
										</Grid>
										
										<Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<HdrStrongOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<TextField
														select
														fullWidth
														onChange={this.handleChange}
														SelectProps={{
															native: true,
															MenuProps: {},
														}}
														InputLabelProps={{shrink: true}}
														name="id_cat_anio"
														label="Año"
														value={this.state.id_cat_anio}
													>
														<option key={0} value={''}>&nbsp;</option>
														{this.state.cat_anio.map(option => (
															<option key={option.anio}
															        value={option.anio}>
																{option.anio}
															</option>
														))}
													</TextField>
												</Grid>
											</Grid>
										</Grid>
										
										<Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
											
											<TextField
												margin="none"
												name="sector"
												label="Sector"
												type="text"
												fullWidth
												value={this.state.sector}
												InputLabelProps={{shrink: true}}
												onChange={(e) => {
													this.handleChange(e);
												}}
											/>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<HdrStrongOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<TextField
														select
														fullWidth
														onChange={this.handleChange}
														SelectProps={{
															native: true,
															MenuProps: {},
														}}
														InputLabelProps={{shrink: true}}
														name="id_cat_trimestre"
														label="Trimestre"
														value={this.state.id_cat_trimestre}
													>
														<option key={0} value={''}>&nbsp;</option>
														{this.state.cat_trimestre.map(option => (
															<option key={option.id_cat_trimestre}
															        value={option.id_cat_trimestre}>
																{option.trimestre}
															</option>
														))}
													</TextField>
												</Grid>
											</Grid>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											
											<TextField
												margin="none"
												name="numero"
												label="Número de Reclamaciones"
												type="text"
												fullWidth
												value={this.state.numero}
												InputLabelProps={{shrink: true}}
												onChange={(e) => {
													this.handleChange(e);
												}}
											/>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											
											<TextField
												margin="none"
												name="folio_atencion"
												label="No. de Folio de Atención"
												type="text"
												fullWidth
												value={this.state.folio_atencion}
												InputLabelProps={{shrink: true}}
												onChange={(e) => {
													this.handleChange(e);
												}}
											/>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<TextField
												className={'margin-0'}
												select
												fullWidth
												margin="dense"
												InputLabelProps={{shrink: true}}
												onChange={(e) => {
													this.handleChange(e);
												}}
												disabled={this.state.tipo === 'view'}
												SelectProps={{
													native: true,
													MenuProps: {},
												}}
												required
												name="id_cat_estado_concluido_pendiente"
												label="Estado Concluido / Pendiente"
												value={this.state.id_cat_estado_concluido_pendiente}
											>
												<option key={0} value={''}>&nbsp;</option>
												{this.state.cat_estado_concluido_pendiente.map(option => (
													<option key={option.id_cat_estado_concluido_pendiente}
													        value={option.id_cat_estado_concluido_pendiente}>
														{option.estado_concluido_pendiente}
													</option>
												))}
											</TextField>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<CalendarTodayOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<KeyboardDatePicker
														fullWidth
														clearable
														format={'dd/MM/yyyy'}
														inputProps={{readOnly: true}}
														InputLabelProps={{shrink: true}}
														KeyboardButtonProps={{
															'aria-label': 'change date',
														}}
														label="Fecha Reclamación"
														value={this.state.fecha_reclamacion}
														onChange={(date) => {
															this.handleChange(null, null, null, date, 'fecha_reclamacion');
														}}
														clearLabel={'Limpiar'}
														okLabel={'Aceptar'}
														cancelLabel={'Cancelar'}
														required
													/>
												</Grid>
											</Grid>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<CalendarTodayOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<KeyboardDatePicker
														fullWidth
														clearable
														format={'dd/MM/yyyy'}
														inputProps={{readOnly: true}}
														InputLabelProps={{shrink: true}}
														KeyboardButtonProps={{
															'aria-label': 'change date',
														}}
														label="Fecha Atención"
														value={this.state.fecha_atencion}
														onChange={(date) => {
															this.handleChange(null, null, null, date, 'fecha_atencion');
														}}
														clearLabel={'Limpiar'}
														okLabel={'Aceptar'}
														cancelLabel={'Cancelar'}
														required
													/>
												</Grid>
											</Grid>
										</Grid>
										
										{/*<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<CalendarTodayOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<KeyboardDatePicker
														fullWidth
														clearable
														format={'dd/MM/yyyy'}
														inputProps={{readOnly: true}}
														KeyboardButtonProps={{
															'aria-label': 'change date',
														}}
														label="Fecha Federativa"
														value={this.state.fecha_federativa}
														onChange={(date) => {
															this.handleChange(null, null, null, date, 'fecha_federativa');
														}}
														clearLabel={'Limpiar'}
														okLabel={'Aceptar'}
														cancelLabel={'Cancelar'}
														required
													/>
												</Grid>
											</Grid>
										</Grid>*/}
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<HdrWeakOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<TextField
														select
														fullWidth
														onChange={(e) => {
															this.handleChange(e);
															this.ListMunicipio(e.target.value);
														}}
														SelectProps={{
															native: true,
															MenuProps: {},
														}}
														InputLabelProps={{shrink: true}}
														name="id_cat_entidad_federativa"
														label="Entidad Federativa"
														value={this.state.id_cat_entidad_federativa}
													>
														<option key={0} value={''}>&nbsp;</option>
														{this.state.cat_entidad_federativa.map(option => (
															<option key={option.id_cat_entidad_federativa}
															        value={option.id_cat_entidad_federativa}>
																{option.entidad_federativa}
															</option>
														))}
													</TextField>
												</Grid>
											</Grid>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<HdrStrongOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<TextField
														select
														fullWidth
														onChange={(e) => {
															this.handleChange(e);
															this.ListCodigoPostal(e.target.value);
														}}
														SelectProps={{
															native: true,
															MenuProps: {},
														}}
														InputLabelProps={{shrink: true}}
														name="clave_municipio"
														label="Municipio"
														value={this.state.clave_municipio}
													>
														<option key={0} value={''}>&nbsp;</option>
														{this.state.cat_entidades.map(option => (
															<option key={option.clave_municipio}
															        value={option.clave_municipio}>
																{option.municipio}
															</option>
														))}
													</TextField>
												</Grid>
											</Grid>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<HdrStrongOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<TextField
														select
														fullWidth
														onChange={(e) => {
															this.handleChange(e);
															this.ListLocalidad(e.target.value);
														}}
														SelectProps={{
															native: true,
															MenuProps: {},
														}}
														InputLabelProps={{shrink: true}}
														name="codigo_postal"
														label="Código Postal"
														value={this.state.codigo_postal}
													>
														<option key={0} value={''}>&nbsp;</option>
														{this.state.cat_codigo_postal.map(option => (
															<option key={option.codigo_postal}
															        value={option.codigo_postal}>
																{option.codigo_postal}
															</option>
														))}
													</TextField>
												</Grid>
											</Grid>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<HdrStrongOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<TextField
														select
														fullWidth
														onChange={(e) => {
															this.handleChange(e);
															this.ListColonia(e.target.value);
														}}
														SelectProps={{
															native: true,
															MenuProps: {},
														}}
														InputLabelProps={{shrink: true}}
														name="clave_localidad"
														label="Localidad"
														value={this.state.clave_localidad}
													>
														<option key={0} value={''}>&nbsp;</option>
														{this.state.cat_localidad.map(option => (
															<option key={option.clave_localidad}
															        value={option.clave_localidad}>
																{option.localidad}
															</option>
														))}
													</TextField>
												</Grid>
											</Grid>
										</Grid>
										
										<Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<HdrStrongOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<TextField
														select
														fullWidth
														onChange={(e) => {
															this.handleChange(e);
														}}
														SelectProps={{
															native: true,
															MenuProps: {},
														}}
														InputLabelProps={{shrink: true}}
														name="clave_colonia"
														label="Colonia"
														value={this.state.clave_colonia}
													>
														<option key={0} value={''}>&nbsp;</option>
														{this.state.cat_colonia.map(option => (
															<option key={option.clave_colonia}
															        value={option.clave_colonia}>
																{option.colonia}
															</option>
														))}
													</TextField>
												</Grid>
											</Grid>
										</Grid>
										
										{/*<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<ImageAspectRatioOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<TextField type={'text'} fullWidth name="codigo_postal"
													           onChange={this.handleChange}
													           label="Código Postal" autoComplete={'off'}
													           value={this.state.codigo_postal}
													           required
													/>
												</Grid>
											</Grid>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											
											<TextField
												margin="none"
												name="localidad"
												label="Localidad"
												type="text"
												fullWidth
												value={this.state.localidad}
												onChange={(e) => {
													this.handleChange(e);
												}}
												InputLabelProps={{shrink: true}}
												onKeyPress={EnteroSolo}
												inputProps={{maxLength: 50}}
											/>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											
											<TextField
												margin="none"
												name="colonia"
												label="Colonia"
												type="text"
												fullWidth
												value={this.state.colonia}
												onChange={(e) => {
													this.handleChange(e);
												}}
												InputLabelProps={{shrink: true}}
												onKeyPress={EnteroSolo}
												inputProps={{maxLength: 50}}
											/>
										</Grid>*/}
										
										<Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<HdrStrongOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<TextField
														select
														fullWidth
														onChange={this.handleChange}
														SelectProps={{
															native: true,
															MenuProps: {},
														}}
														InputLabelProps={{shrink: true}}
														name="id_cat_robo_identidad"
														label="Posible Robo de Identidad (PORI)"
														value={this.state.id_cat_robo_identidad}
													>
														<option key={0} value={''}>&nbsp;</option>
														{this.state.cat_robo_identidad.map(option => (
															<option key={option.id_cat_robo_identidad}
															        value={option.id_cat_robo_identidad}>
																{option.robo_identidad}
															</option>
														))}
													</TextField>
												</Grid>
											</Grid>
										</Grid>
										
										<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<HdrStrongOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<TextField
														select
														fullWidth
														onChange={this.handleChange}
														SelectProps={{
															native: true,
															MenuProps: {},
														}}
														InputLabelProps={{shrink: true}}
														name="id_cat_medio_recepcion_canal"
														label="Medio de recepción o canal"
														value={this.state.id_cat_medio_recepcion_canal}
													>
														<option key={0} value={''}>&nbsp;</option>
														{this.state.cat_medio_recepcion_canal.map(option => (
															<option key={option.id_cat_medio_recepcion_canal}
															        value={option.id_cat_medio_recepcion_canal}>
																{option.medio_recepcion_canal}
															</option>
														))}
													</TextField>
												</Grid>
											</Grid>
										</Grid>
										
										<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<HdrStrongOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<TextField
														select
														fullWidth
														onChange={this.handleChange}
														SelectProps={{
															native: true,
															MenuProps: {},
														}}
														InputLabelProps={{shrink: true}}
														name="id_cat_nivel_atencion"
														label="Nivel de atención o contacto"
														value={this.state.id_cat_nivel_atencion}
													>
														<option key={0} value={''}>&nbsp;</option>
														{this.state.cat_nivel_atencion.map(option => (
															<option key={option.id_cat_nivel_atencion}
															        value={option.id_cat_nivel_atencion}>
																{option.nivel_atencion}
															</option>
														))}
													</TextField>
												</Grid>
											</Grid>
										</Grid>
									
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<CalendarTodayOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<KeyboardDatePicker
														fullWidth
														clearable
														format={'dd/MM/yyyy'}
														inputProps={{readOnly: true}}
														KeyboardButtonProps={{
															'aria-label': 'change date',
														}}
														InputLabelProps={{shrink: true}}
														label="Fecha de Resolución"
														value={this.state.fecha_resolucion}
														onChange={(date) => {
															this.handleChange(null, null, null, date, 'fecha_resolucion');
														}}
														clearLabel={'Limpiar'}
														okLabel={'Aceptar'}
														cancelLabel={'Cancelar'}
														required
													/>
												</Grid>
											</Grid>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<CalendarTodayOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<KeyboardDatePicker
														fullWidth
														clearable
														format={'dd/MM/yyyy'}
														inputProps={{readOnly: true}}
														KeyboardButtonProps={{
															'aria-label': 'change date',
														}}
														InputLabelProps={{shrink: true}}
														label="Fecha Abono Importe"
														value={this.state.fecha_abono_importe}
														onChange={(date) => {
															this.handleChange(null, null, null, date, 'fecha_abono_importe');
														}}
														clearLabel={'Limpiar'}
														okLabel={'Aceptar'}
														cancelLabel={'Cancelar'}
														required
													/>
												</Grid>
											</Grid>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<CalendarTodayOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<KeyboardDatePicker
														fullWidth
														clearable
														format={'dd/MM/yyyy'}
														inputProps={{readOnly: true}}
														KeyboardButtonProps={{
															'aria-label': 'change date',
														}}
														InputLabelProps={{shrink: true}}
														label="Fecha de Notificación al Usuario"
														value={this.state.fecha_notificacion}
														onChange={(date) => {
															this.handleChange(null, null, null, date, 'fecha_notificacion');
														}}
														clearLabel={'Limpiar'}
														okLabel={'Aceptar'}
														cancelLabel={'Cancelar'}
														required
													/>
												</Grid>
											</Grid>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<HdrStrongOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<TextField
														select
														fullWidth
														onChange={this.handleChange}
														SelectProps={{
															native: true,
															MenuProps: {},
														}}
														InputLabelProps={{shrink: true}}
														name="id_cat_sentido_resolucion"
														label="Sentido de la Resolución"
														value={this.state.id_cat_sentido_resolucion}
													>
														<option key={0} value={''}>&nbsp;</option>
														{this.state.cat_sentido_resolucion.map(option => (
															<option key={option.id_cat_sentido_resolucion}
															        value={option.id_cat_sentido_resolucion}>
																{option.sentido_resolucion}
															</option>
														))}
													</TextField>
												</Grid>
											</Grid>
										</Grid>
										
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<HdrStrongOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<TextField
														select
														fullWidth
														onChange={this.handleChange}
														SelectProps={{
															native: true,
															MenuProps: {},
														}}
														InputLabelProps={{shrink: true}}
														name="id_cat_tipo_persona"
														label="Tipo de Persona"
														value={this.state.id_cat_tipo_persona}
													>
														<option key={0} value={''}>&nbsp;</option>
														{this.state.cat_tipo_persona.map(option => (
															<option key={option.id_cat_tipo_persona}
															        value={option.id_cat_tipo_persona}>
																{option.tipo_persona}
															</option>
														))}
													</TextField>
												</Grid>
											</Grid>
										</Grid>
										
										<Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
											<Grid container spacing={1} alignItems={"flex-end"}>
												<Grid item className={'w-30-px'}>
													<HdrStrongOutlined className={'w-100 text-gray'}/>
												</Grid>
												<Grid item className={'w-100-30-px'}>
													<TextField
														select
														fullWidth
														onChange={this.handleChange}
														SelectProps={{
															native: true,
															MenuProps: {},
														}}
														InputLabelProps={{shrink: true}}
														name="id_cat_sexo"
														label="Sexo"
														value={this.state.id_cat_sexo}
													>
														<option key={0} value={''}>&nbsp;</option>
														{this.state.cat_sexo.map(option => (
															<option key={option.id_cat_sexo}
															        value={option.id_cat_sexo}>
																{option.sexo}
															</option>
														))}
													</TextField>
												</Grid>
											</Grid>
										</Grid>
										
										<Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
											
											<TextField
												margin="none"
												name="edad"
												label="Edad"
												type="text"
												fullWidth
												value={this.state.edad}
												onChange={(e) => {
													this.handleChange(e);
												}}
												InputLabelProps={{shrink: true}}
												onKeyPress={EnteroSolo}
												inputProps={{maxLength: 3}}
											/>
										</Grid>
										
										<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
											Producto y/o Servicio (en su caso)
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<TextField
												className={'margin-0'}
												select
												fullWidth
												margin="dense"
												onChange={(e) => {
													this.handleChange(e);
													this.ListProductoServicio(e.target.value);
												}}
												disabled={this.state.tipo === 'view'}
												SelectProps={{
													native: true,
													MenuProps: {},
												}}
												required
												name="operacion"
												label="Operación"
												InputLabelProps={{shrink: true}}
												value={this.state.operacion}
											>
												<option key={0} value={''}>&nbsp;</option>
												{this.state.cat_operacion.map(option => (
													<option key={option.operacion}
													        value={option.operacion}>
														{option.operacion}
													</option>
												))}
											</TextField>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<TextField
												className={'margin-0'}
												select
												fullWidth
												margin="dense"
												onChange={(e) => {
													this.handleChange(e);
													this.ListProductoServicio(this.state.operacion, e.target.value);
												}}
												disabled={this.state.tipo === 'view'}
												SelectProps={{
													native: true,
													MenuProps: {},
												}}
												required
												name="producto"
												label="Producto y/o Servicio"
												InputLabelProps={{shrink: true}}
												value={this.state.producto}
											>
												<option key={0} value={''}>&nbsp;</option>
												{this.state.cat_producto_servicio.map(option => (
													<option key={option.codigo_producto}
													        value={option.codigo_producto}>
														{option.producto}
													</option>
												))}
											</TextField>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											<TextField
												className={'margin-0'}
												select
												fullWidth
												margin="dense"
												onChange={(e) => {
													this.handleChange(e);
													this.ListProductoServicio(this.state.operacion, this.state.producto, e.target.value);
												}}
												disabled={this.state.tipo === 'view'}
												SelectProps={{
													native: true,
													MenuProps: {},
												}}
												required
												name="tipo_credito"
												label="Tipo de Crédito"
												InputLabelProps={{shrink: true}}
												value={this.state.tipo_credito}
											>
												<option key={0} value={''}>&nbsp;</option>
												{this.state.cat_tipo_credito.map(option => (
													<option key={option.tipo_credito}
													        value={option.tipo_credito}>
														{option.tipo_credito}
													</option>
												))}
											</TextField>
										</Grid>
										
										
										<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
											<TextField
												className={'margin-0'}
												select
												fullWidth
												margin="dense"
												onChange={(e) => {
													this.handleChange(e);
												}}
												disabled={this.state.tipo === 'view'}
												SelectProps={{
													native: true,
													MenuProps: {},
												}}
												required
												name="causa"
												label="Causa"
												InputLabelProps={{shrink: true}}
												value={this.state.causa}
											>
												<option key={0} value={''}>&nbsp;</option>
												{this.state.cat_causa.map(option => (
													<option key={option.causa}
													        value={option.causa}>
														{option.causa}
													</option>
												))}
											</TextField>
										</Grid>
										
									
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											
											<TextField
												className={'margin-0'}
												select
												fullWidth
												margin="dense"
												onChange={(e) => {
													this.handleChange(e);
												}}
												disabled={this.state.tipo === 'view'}
												SelectProps={{
													native: true,
													MenuProps: {},
												}}
												required
												name="id_cat_monetario"
												label="¿El asunto es monetario?"
												InputLabelProps={{shrink: true}}
												value={this.state.id_cat_monetario}
											>
												<option key={0} value={''}>&nbsp;</option>
												{this.state.cat_monetario.map(option => (
													<option key={option.id_cat_monetario}
													        value={option.id_cat_monetario}>
														{option.monetario}
													</option>
												))}
											</TextField>
										</Grid>
										
										
										
										
										{/*<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
											Los siguientes datos aplican si el medio de recepción es:
										</Grid>
										
										<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
											
											<TextField
												margin="none"
												name="colonia"
												label="Folio Institución (no requerido)"
												type="text"
												fullWidth
												value={this.state.colonia}
												onChange={(e) => {
													this.handleChange(e);
												}}
												InputLabelProps={{shrink: true}}
												onKeyPress={EnteroSolo}
												inputProps={{maxLength: 50}}
											/>
										</Grid>
										
										<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
											
											<TextField
												className={'margin-0'}
												select
												fullWidth
												margin="dense"
												onChange={(e) => {
													this.handleChange(e);
												}}
												disabled={this.state.tipo === 'view'}
												SelectProps={{
													native: true,
													MenuProps: {},
												}}
												required
												InputLabelProps={{shrink: true}}
												name="id_cat_tipo_cliente"
												label="Reversa de Folio CONDUSEF"
												value={this.state.id_cat_tipo_cliente}
											>
												<option key={0} value={''}>&nbsp;</option>
												{this.state.listar_cat_tipo_cliente.map(option => (
													<option key={option.id_cat_tipo_cliente} value={option.id_cat_tipo_cliente}>
														{option.tipo_cliente}
													</option>
												))}
											</TextField>
										</Grid>*/}
										
										
										<Grid item xs={12} sm={12} md={12} lg={12} xl={12} align={'left'}>
										</Grid>
										
										<Grid item xs={6} sm={6} md={6} lg={6} xl={6} align={'left'}>
											<Button onClick={this.close} color="default" variant="contained">
												{'Cancelar'}
											</Button>
										</Grid>
										
										<Grid item xs={6} sm={6} md={6} lg={6} xl={6} align={'right'}>
											<Button onClick={this.save} color="primary" variant="contained">
												{this.props.tipo === 'add' ? 'Agregar':'Modificar'}
											</Button>
										</Grid>
									
									</Grid>
								</div>
							</Grid>
						
						</Grid>
					
					</DialogContent>
				
				</Dialog>
			
			</div>
		);
	}
}

ModalReclamaciones.propTypes = {
	componente: PropTypes.element,
	tipo: PropTypes.string.isRequired,
	item: PropTypes.object.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
	catalogos: PropTypes.object.isRequired,
	catalogosEntidad: PropTypes.func.isRequired,
	catalogosEntidadCodigoPostal: PropTypes.func.isRequired,
	catalogosEntidadLocalidad: PropTypes.func.isRequired,
	catalogosEntidadColonia: PropTypes.func.isRequired,
	catalogosProductoServicio: PropTypes.func.isRequired,
};

export default ModalReclamaciones;
